module.exports = __webpack_public_path__ + "img/intelligent-security-solutionsimg-4.83131d19.png";